<template>
    <!-- 专户管理 -->
    <div class="join-ent-box">
        <div class="box-head">
            <span>专户管理</span>
            <div>
                <el-button type="primary" @click="tomodel">专户管理资料模板</el-button>
                <el-button type="primary" @click="toEdit">编辑</el-button>
            </div>
            
        </div>
        <div class="box-con">
            <!-- 农民工专户开户证明 -->
            <el-card class="box-card" style="margin:0;">
                <div slot="header" class="clearfix">
                    <span>农民工专户开户证明</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList1" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 专户到账凭证 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix" style="display: flex;align-content: center;align-items: center;justify-content: space-between;">
                    <span>专户到账凭证</span>
                    <el-button type="text" @click="moreList2">更多></el-button>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList2" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 专户到账凭证 -->
            <!-- <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>专户到账凭证</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList3" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.url" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card> -->
            <!-- 工资发放审核 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>工资发放审核</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList3" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 银行三方协议 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>银行三方协议</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList4" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 工资流水 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>工资流水</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList5" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 工资发放公示 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>工资发放公示</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList6" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 保障金保函 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>保障金保函</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList7" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 工资委托代付协议 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>工资委托代付协议</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList8" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 农民工维权工作组成立文件 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>农民工维权工作组成立文件</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList9" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.url" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 工程款支付担保或履约担保 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>工程款支付担保或履约担保</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList10" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 专户拨付凭证 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>专户拨付凭证</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList11" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 其他工程款拨付凭证 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>其他工程款拨付凭证</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList12" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 建设单位支付给施工总承包企业工程预付款银行付款凭证 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>建设单位支付给施工总承包企业工程预付款银行付款凭证</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList13" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 劳资专管员任命书 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>劳资专管员任命书</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList14" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 维权信息公示牌照片 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>维权信息公示牌照片</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList15" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
            <!-- 分包企业委托施工总承包企业发放工资委托书 -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>分包企业委托施工总承包企业发放工资委托书</span>
                </div>
                <div class="box-img-con">
                    <div class="img-item" v-for="(item,index) in fileList16" :key="index">
                        <el-image 
                            style="max-width: 100%; max-height: 100%;"
                            :src="item.showUrl" 
                            :preview-src-list="item.srcList">
                        </el-image>
                    </div>
                </div>
            </el-card>
        </div>
        <!-- 弹出框 -->
        <el-dialog
            title="专户到账凭证"
            :visible.sync="dialogVisible"
            width="30%">
            <el-card class="box-card" v-for="(item,index) in specialList" :key="index">
                <div slot="header" class="clearfix">
                    <span>{{item.updateDate}}</span>
                </div>
                <div class="box-img-con">
                    <el-image 
                        v-for="(obj,i) in item.accountings"
                        :key="i"
                        style="max-width: 10vh; max-height: 10vh"
                        :src="obj" 
                        :preview-src-list="[item.srcList]">
                    </el-image>
                </div>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port';
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            groupName:'',
            fileList1:[],
            fileList2:[],
            fileList3:[],
            fileList4:[],
            fileList5:[],
            fileList6:[],
            fileList7:[],
            fileList8:[],
            fileList9:[],
            fileList10:[],
            fileList11:[],
            fileList12:[],
            fileList13:[],
            fileList14:[],
            fileList15:[],
            fileList16:[],
            //弹出框
            dialogVisible:false,
            specialAccountId:'',//
            specialList:[],
        }
    },
    mounted(){
        this.groupId=util.session.get('groupId')
        this.getData()
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            myHttp.getSpecialAccountByProjectId({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.proSpecialAccount
                    if(data){
                        // that.form.id = data.id
                        that.specialAccountId = data.id
                        
                        that.fileList1 = []
                        if(data.workersAccount && ''!=data.workersAccount){
                            var lis = data.workersAccount.split(',')
                            for(var i=0;i<lis.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis[i]
                                obj.showUrl = base.httpCtx + lis[i]
                                obj.srcList = [base.httpCtx + lis[i]]
                                that.fileList1.push(obj)
                            }
                        }
                        that.fileList2 = []
                        if(data.accounting && ''!=data.accounting){
                            var lis1 = data.accounting.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList2.push(obj)
                            }
                        }
                        that.fileList3 = []
                        if(data.wageAudit && ''!=data.wageAudit){
                            var lis1 = data.wageAudit.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList3.push(obj)
                            }
                        }
                        that.fileList4 = []
                        if(data.bankAgreement && ''!=data.bankAgreement){
                            var lis1 = data.bankAgreement.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList4.push(obj)
                            }
                        }
                        that.fileList5 = []
                        if(data.wageWater && ''!=data.wageWater){
                            var lis1 = data.wageWater.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList5.push(obj)
                            }
                        }
                        that.fileList6 = []
                        if(data.waterNotice && ''!=data.waterNotice){
                            var lis1 = data.waterNotice.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList6.push(obj)
                            }
                        }
                        that.fileList7 = []
                        if(data.cashDeposit && ''!=data.cashDeposit){
                            var lis1 = data.cashDeposit.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList7.push(obj)
                            }
                        }
                        that.fileList8 = []
                        if(data.wageAgreement && ''!=data.wageAgreement){
                            var lis1 = data.wageAgreement.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList8.push(obj)
                            }
                        }
                        that.fileList9 = []
                        if(data.ruralWorkers && ''!=data.ruralWorkers){
                            var lis1 = data.ruralWorkers.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList9.push(obj)
                            }
                        }
                        that.fileList10 = []
                        if(data.bidBond && ''!=data.bidBond){
                            var lis1 = data.bidBond.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList10.push(obj)
                            }
                        }
                        that.fileList11 = []
                        if(data.voucher && ''!=data.voucher){
                            var lis1 = data.voucher.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList11.push(obj)
                            }
                        }
                        that.fileList12 = []
                        if(data.disbursementVoucher && ''!=data.disbursementVoucher){
                            var lis1 = data.disbursementVoucher.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList12.push(obj)
                            }
                        }
                        that.fileList13 = []
                        if(data.constructionUnitShal && ''!=data.constructionUnitShal){
                            var lis1 = data.constructionUnitShal.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList13.push(obj)
                            }
                        }
                        that.fileList14 = []
                        if(data.letter && ''!=data.letter){
                            var lis1 = data.letter.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList14.push(obj)
                            }
                        }
                        that.fileList15 = []
                        if(data.rightInformation && ''!=data.rightInformation){
                            var lis1 = data.rightInformation.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList15.push(obj)
                            }
                        }
                        that.fileList16 = []
                        if(data.subcontractorEntrusts && ''!=data.subcontractorEntrusts){
                            var lis1 = data.subcontractorEntrusts.split(',')
                            for(var i=0;i<lis1.length;i++){
                                var obj = []
                                obj.uid = i
                                obj.url = lis1[i]
                                obj.showUrl = base.httpCtx + lis1[i]
                                obj.srcList = [base.httpCtx + lis1[i]]
                                that.fileList16.push(obj)
                            }
                        }
                    }
                }
            })
        },
        //编辑
        toEdit(){
            this.$router.push({path:'/speBankInfo'})
        },
        tomodel(){
             this.$router.push({path:'/speBankFolder'})
        },
        //点击展示
        moreList2(){
            this.dialogVisible = true
            this.getAccoountList()
        },
        //展示专户到账凭证
        getAccoountList(){
            var that = this
            myHttp.getProSpecialAccountInfoList({
                specialAccountId:this.specialAccountId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    
                    var list = resp.data.data.list||[]
                    for(var i=0;i<list.length;i++){
                        // list[i].accountings = base.httpCtx+list[i].accounting
                        list[i].accountings = list[i].accounting?list[i].accounting.split(','):[]
                        list[i].srcList = []
                        for(var j=0;j<list[i].accountings.length;j++){
                            list[i].srcList.push(base.httpCtx+list[i].accountings[i])
                            list[i].accountings[i] = base.httpCtx+list[i].accountings[i]
                        }
                    }
                    that.specialList = list
                }
            })
        },
    }
}
</script>

<style scoped>
    .join-ent-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .box-head{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 2px solid #048ff9;
        padding: 0 2vw;
        background: #fff;
        justify-content: space-between;
    }
    .box-con{
        width: 100%;
        height: calc( 100% - 5vh );
        position: relative;
        padding: 0;
        overflow: auto;
    }
    .box-card{
        margin-top: 2vh;
    }
    .clearfix{
        text-align: left;
        font-size: 16px;
        color: #048ff9;
    }
    .box-img-con{
        width: 100%;
        height: auto;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        justify-items: flex-start;
        align-content: flex-start;
        align-items: flex-start;
        padding: 1vh;
    }
    .img-item{
        width: 10%;
        height: 16vh;
        position: relative;
        padding: 1vh 0.6vw;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        border: 1px dashed #ddd;
    }
</style>

<style>

</style>